export default function restrictKeys(event) {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);

  // Allow numbers (0-9), spaces, commas, and the backspace key
  if (!/^[0-9,\s\b]+$/.test(keyValue)) {
    event.preventDefault();
  }
}
